import styled from 'styled-components'

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  font-size: 16px;
  margin-bottom: 16px;

  > div:first-child {
    flex: 1;
  }

  > div:nth-child(2) {
    flex: 0.4;
  }

  > div {
    flex: 0.7;
    margin-left: 16px;
  }
`

export const ValueFieldWrapper = styled.div`
  display: none;

  &:has(*) {
    display: block;
  }

  &:has(div > div > .react-select--is-disabled) {
    display: none;
  }

  &:has(input[disabled]) {
    display: none;
  }
`
